export default __webpack_public_path__ + "static/media/Arles.3892e65d.jpg";